<template>
  <div>
    <v-tooltip v-if="!hideImage" bottom nudge-top="15px" max-width="250px" :disabled="!hasDescription">
      <template v-slot:activator="{ on, attrs }" class="p-relative">
        <a
            href="#"
            @click.prevent="loadPreview"
            class="circle clickable justify-center flex-column align-center d-flex mt-16 mx-auto no-underline position-relative"
        >
          <v-col align="center">
            <v-img :src="type.circle_logo"  class="circle responsive-img"
                   v-bind="attrs"
                   v-on="on" />
          </v-col>
        </a>
      </template>
      <p class="text-center">{{ type.description }}</p>
    </v-tooltip>
    <div class="d-flex justify-center align-center">
      <h4 class="text-center d-inline-block">
        <span @click="loadPreview" v-if="!hideName">{{ translatedName }}</span>

      </h4>
    </div>
    <type-help-dialog v-model="showTypeHelp" v-if="showTypeHelp" :src="type.help_link" @close="showTypeHelp = false" />
    <type-preview-dialog v-model="showTypePreview" v-if="showTypePreview" @close="showTypePreview = false" @upgrade = "upgrade()"
                         :type="this.type" />
  </div>
</template>

<script>
import TypeHelpDialog from "./TypeHelpDialog";
import TypePreviewDialog from "./TypePreviewDialog";
import GameModule from "src/store/modules/Game.module";
import { gameTypeTranslate } from "src/helpers/Utilities"

export default {
  name: "TypeCircle",
  components: { TypeHelpDialog, TypePreviewDialog },
  props: { type: Object, hideName: Boolean, hideImage: Boolean },
  data: () => {
    return {
      showTypeHelp: false,
      showTypePreview: false,
    };
  },
  computed: {
    hasDescription() {
      return !!this.type.description && this.type.description !== null && this.type.description !== "null";
    },
    auth() {
      return this.$store.state.AuthModule.user;
    },

    translatedName() {
      return gameTypeTranslate(this.type.name);
    }
  },
  methods: {
    upgrade() {
      this.showTypePreview = false;
      this.$emit("showUpgrade", true);
    },
    help() {
      this.showTypeHelp = true;
    },
    loadPreview() {
      this.showTypePreview = true;
    },
    createGame() {
      const types = GameModule.types;
      const data = {
        name: this.translatedName + " - " + this.auth.name,
        type_id: this.type.id,
        share: true
      };
      this.$store.dispatch(types.SAVE, data).then((game) => {
        this.$store.commit(types.GET, game);
        this.$store.commit(types.SHOW_IN_TOOLBAR, true);
        this.$router.push({
          name: "game-form",
          params: { id: game.id },
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">

.clickable {
  cursor: pointer;
}

.no-underline {
  text-decoration: none;
  color: black;
}

.help_link {
  position: relative;
  top: 5px;
}

.responsive-img {
  max-height: 175px;
  max-width: 175px;
}

@media (max-width: 600px) {
  .responsive-img {
    max-height: 200px; /* Adjust for mobile */
    max-width: 200px;
  }
}

</style>
